import DataviewPane from './DataviewPane';

export default DataviewPane;
